<script>
    /* Executable code section of the program */
    // Components Importation
    import MyProfile from "./MyProfilePage.svelte";
    import ChangePassword from "./ChangePassword.svelte"
    import Loader from "../../components/Loader.svelte";

  //Tools importation
  import {auth} from "../../apis/APIS"
  import {isProtectedRoute} from "../../apis/storage"
  import { onMount } from "svelte";
  import { onAuthStateChanged } from "firebase/auth";
  import ChangeEmail from "./ChangeEmail.svelte";

  
  //Auxiliary Variables
  let isLoadedContent = false;
  //Function to go back
  const goBack= () => {
    window.history.back();
  }

      //Logged-in session verification
  //Initial function execution
  onMount(async () => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        $isProtectedRoute = true;
        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });

    /* End of the section */
</script>
<!-- Section to place the HTML code -->

{#if $isProtectedRoute}
  {#if isLoadedContent}
  <section class="myProfileContainer">
    <div class="backBtnContainer">
      <button class="backBtn" on:click="{goBack}"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
      </svg> Go Back</button>
    </div>
      <div class="contentContainer">
          <div class="accordion" id="accordionExample">
              <div class="accordion-item">
                <h1 class="accordion-header">
                  <button class="accordion-button tittleHeader" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                    My Profile
                  </button>
                </h1>
                <div id="collapseOne" class="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                  <div class="accordion-body profileContainer">
                      <MyProfile/>
                  </div>
                </div>
              </div>
              <div class="accordion-item">
                <h1 class="accordion-header">
                  <button class="accordion-button collapsed tittleHeader" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                    Change Password
                  </button>
                </h1>
                <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                      <ChangePassword/>
                  </div>
                </div>
              </div><!-- 
              <div class="accordion-item">
                <h1 class="accordion-header">
                  <button class="accordion-button collapsed tittleHeader" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                    Changes Email
                  </button>
                </h1>
                <div id="collapseThree" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                  <div class="accordion-body">
                    <ChangeEmail/>
                  </div>
                </div>
              </div> -->
            </div>
      </div>
  </section>
    {:else}
    <Loader/>
  {/if}
{/if}


<!-- End of the section -->
<style>
    /* Section to place the code styles */

    .myProfileContainer{
        width: 100%;
        height: auto;
        min-height: 80vh;
        background-color: #f4f4f4;
        padding: 30px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .contentContainer{
        width: 90%;
        padding: 20px;
        background-color: white;
    }
    .tittleHeader{
        font-size: 25px;
    }
  /* Back Button styles */
    .backBtnContainer{
    width: 90%;
    display: flex;
    justify-content: flex-start;
    padding: 20px 0;
  }
  .backBtn{
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover{
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }


    /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .contentContainer{
        width: 100%;
        padding: 20px;
        background-color: white;
    }
}
/* /////////Cellphones ///////// */
@media (max-width: 700px) {
    .contentContainer{
        width: 100%;
        padding: 10px;
        background-color: white;
    }
}


    /* End of the section */
</style>
